"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPoEComponentBuffer = exports.findComponentSubmissionDeadline = void 0;
const moment_1 = __importDefault(require("moment"));
const component_1 = require("../domain/component");
const seriesHelpers_1 = require("./seriesHelpers");
const checkDate = (examDates, zoneId) => {
    const dateWithZoneId = examDates.find((examDate) => examDate.zoneId === zoneId);
    const dateWithZoneIdNull = examDates.find((examDate) => examDate.zoneId === null);
    return dateWithZoneId || dateWithZoneIdNull;
};
const examUploadDate = (date, days, buffer) => {
    const examSubmission = new Date(date);
    examSubmission.setDate(examSubmission.getDate() + days + buffer);
    return examSubmission.toISOString();
};
const findComponentSubmissionDeadlineDate = (component, digitalSubmissionType, seriesId, centreZoneId) => {
    var _a;
    const today = (0, moment_1.default)().toISOString();
    const componentSeries = component.series.find((series) => series.id === seriesId);
    const examinedSubmissionWindow = componentSeries === null || componentSeries === void 0 ? void 0 : componentSeries.submissionWindow;
    const marksSubmissionWindow = componentSeries === null || componentSeries === void 0 ? void 0 : componentSeries.marksSubmissionWindow;
    const examDates = (_a = componentSeries === null || componentSeries === void 0 ? void 0 : componentSeries.examDates) !== null && _a !== void 0 ? _a : [];
    const examDateObject = checkDate(examDates, centreZoneId);
    const examDeadlineFromExamDate = (examDateObject === null || examDateObject === void 0 ? void 0 : examDateObject.submissionOffset) && examUploadDate(examDateObject.date, examDateObject.submissionOffset.date, 0);
    if (component.isPoE) {
        return examDeadlineFromExamDate;
    }
    const submissionWindow = digitalSubmissionType === component_1.DigitalSubmissionType.MARKS ? marksSubmissionWindow : examinedSubmissionWindow;
    if (submissionWindow) {
        return submissionWindow.end;
    }
    const examBuffer = (examDateObject === null || examDateObject === void 0 ? void 0 : examDateObject.submissionOffset)
        ? examUploadDate(examDateObject.date, examDateObject.submissionOffset.date, examDateObject.submissionOffset.buffer)
        : '';
    if (!submissionWindow && examBuffer > today) {
        return examDeadlineFromExamDate;
    }
};
const findComponentSubmissionDeadline = (component, digitalSubmissionType, seriesId, centreZoneId) => {
    const deadline = findComponentSubmissionDeadlineDate(component, digitalSubmissionType, seriesId, centreZoneId);
    return deadline ? (0, moment_1.default)(deadline) : null;
};
exports.findComponentSubmissionDeadline = findComponentSubmissionDeadline;
/**
 * @param examDate PoE component exam date
 * @param series related series to take submission window from
 * @returns difference (in days) between exam date and latest series submission buffer date
 */
const getPoEComponentBuffer = (examDate, series) => {
    const latestWindowBuffer = (0, seriesHelpers_1.getLatestBufferSubmissionWindow)(series);
    const buffer = (0, moment_1.default)(latestWindowBuffer).diff((0, moment_1.default)(examDate), 'days');
    return buffer > 0 ? buffer : 0;
};
exports.getPoEComponentBuffer = getPoEComponentBuffer;
